import { SimpleGrid } from '@chakra-ui/react';

import { useAppDispatch } from 'hooks';

import FormInput from 'components/fields/home/FormInput';
import Divider from 'views/home_form/components/Divider';

import { changeDwellingUnderwritingHeader } from 'reducers/homePersonalFormReducer';

import { SECTIONS } from 'views/home_form/constants';

import type { APIPersonalHomeApplicationForm } from 'types/api.types';

interface UnderwritingHeaderProps {
  dwelling: APIPersonalHomeApplicationForm['dwellings'][0];
  index: number;
}

const UnderwritingHeader = ({ dwelling, index }: UnderwritingHeaderProps) => {
  const dispatch = useAppDispatch();

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    dispatch(changeDwellingUnderwritingHeader({ index, name, value }));
  };

  return (
    <>
      <Divider mb="15px">Underwriting Header</Divider>
      <SimpleGrid columns={6} spacing="20px" mb="20px">
        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Premium Table"
          name="premium_table"
          value={dwelling.underwriting_header.premium_table}
          onChange={onInputChange}
        />

        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Town ID Code"
          name="town_id_code"
          value={dwelling.underwriting_header.town_id_code}
          onChange={onInputChange}
        />

        <FormInput
          section={SECTIONS.DWELLINGS}
          label="No. of Attachments"
          name="no_of_attachments"
          value={dwelling.underwriting_header.no_of_attachments}
          onChange={onInputChange}
        />
      </SimpleGrid>
    </>
  );
};

export default UnderwritingHeader;
